var _defs, _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgIr3Logo(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "512px",
    height: "512px",
    viewBox: "0 0 512 512",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "Centred") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("circle", {
    id: "path-1",
    cx: 196,
    cy: 213.581714,
    r: 196
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Centred",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group",
    transform: "translate(60.000000, 42.418286)"
  }, /*#__PURE__*/React.createElement("polygon", {
    id: "Path-4",
    fill: "#1565C0",
    points: "373.108463 297.581714 192.039481 402.771169 199.359511 416.500198 333.002653 353.581714"
  }), /*#__PURE__*/React.createElement("polyline", {
    id: "Path-3",
    fill: "#1565C0",
    points: "59.0687089 73.5817138 213.685775 2.84217094e-14 220.319984 12.6650625 19.3191116 129.581714"
  }), /*#__PURE__*/React.createElement("mask", {
    id: "mask-2",
    fill: "white"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#path-1"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Mask"
  }), /*#__PURE__*/React.createElement("polyline", {
    id: "Path-2",
    fill: "#1565C0",
    mask: "url(#mask-2)",
    points: "19.3646616 297.581714 19.5615654 297.52218 389.798295 185.581714 389.798295 241.145205 58.9866832 353.581714"
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "Path",
    fill: "#1565C0",
    mask: "url(#mask-2)",
    points: "2.2115318 185.581714 333.058759 73.5817138 373.108463 129.581714 2.2115318 241.145205"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle",
    fill: "#2196F3",
    mask: "url(#mask-2)",
    x: 0,
    y: 297.581714,
    width: 392,
    height: 56
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle",
    fill: "#2196F3",
    mask: "url(#mask-2)",
    x: 0,
    y: 185.581714,
    width: 392,
    height: 56
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle",
    fill: "#2196F3",
    mask: "url(#mask-2)",
    x: 0,
    y: 73.5817138,
    width: 392,
    height: 56
  })), /*#__PURE__*/React.createElement("path", {
    d: "M228,32 L284,32 L284,88 L268,88 L268,48 L228,48 L228,32 Z",
    id: "Combined-Shape",
    fill: "#1565C0",
    transform: "translate(256.000000, 60.000000) rotate(17.000000) translate(-256.000000, -60.000000) "
  }))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIr3Logo);
export default __webpack_public_path__ + "static/media/ir3Logo.05be616487c36f1309b876dd74e1d950.svg";
export { ForwardRef as ReactComponent };